import React, { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from '../../../../ui-library';
import './CellDocLibraryLinkDownload.css';

type Option = { id: string; text: string };

type CellDocLibraryLinkDownloadProps = {
    options: Option[];
    onDownload: (id: string, fileName?: string) => void;
    onDelete: (id: string, content: string) => void;
    deleteInProgress: Record<string, boolean>;
    downloadInProgress: Record<string, boolean>;
    productName: string;
    documentMetadataName: string;
    documentFileNames: Record<string, string>;
};

const CellDocLibraryLinkDownload = ({
    options, onDownload, onDelete, deleteInProgress, downloadInProgress, productName,
    documentMetadataName, documentFileNames,
}: CellDocLibraryLinkDownloadProps) => {
    const { t } = useTranslation();
    const button = (id: string, text: string, callback: (val: string, content?: string) => void, inProgress: boolean, confirmationContent?: string) => (
        <button
            type="button"
            disabled={inProgress}
            className="table-cell_linked cell-pdf-view"
            onClick={() => callback(id, confirmationContent)}
        >
            {inProgress ? <Loader/> : t(text).toLowerCase()}
        </button>
    );

    const downloadOptions = useMemo(() => options.map((item) => (
        <Fragment key={item.id}>
            <span>{item.text.toUpperCase()}</span>
            {button(item.id, 'research.downloadDocument', onDownload, downloadInProgress[item.id], documentFileNames[item.text])}
            {button(item.id, 'clientDashboard.delete', onDelete, deleteInProgress?.[item.id], t('advisoryDashboard.documents.deleteContent', { lang: item.text.toUpperCase(), doc: documentMetadataName, product: productName }))}
        </Fragment>
    )), [options, downloadInProgress, deleteInProgress, onDelete, onDownload, documentFileNames, t, documentMetadataName, productName]);

    return <div className="CellDocLibraryLinkDownload">{downloadOptions}</div>;
};

export default CellDocLibraryLinkDownload;
